import { ClubGoal } from './club-goal';

export class ClubGoalCollection{

    constructor(added:ClubGoal[], removed:ClubGoal[]) {
        this.Added = added;
        this.Removed = removed;
    }

    public Added:ClubGoal[];
    public Removed:ClubGoal[];
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/club-goal-collection.ts